"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniqueBatchQueue = void 0;
var tslib_1 = require("tslib");
var batch_queue_1 = require("./batch-queue");
var UniqueBatchQueue = /** @class */function (_super) {
  tslib_1.__extends(UniqueBatchQueue, _super);
  function UniqueBatchQueue(batchPeriod, keyExtractor, handler) {
    var _this = _super.call(this, batchPeriod, handler) || this;
    _this.keyExtractor = keyExtractor;
    _this.seenItems = new Set();
    return _this;
  }
  UniqueBatchQueue.prototype.add = function (item) {
    var key = this.keyExtractor(item);
    if (!this.seenItems.has(key)) {
      _super.prototype.add.call(this, item);
      this.seenItems.add(key);
    }
  };
  UniqueBatchQueue.prototype.handleBatch = function () {
    _super.prototype.handleBatch.call(this);
    this.seenItems.clear();
  };
  return UniqueBatchQueue;
}(batch_queue_1.BatchQueue);
exports.UniqueBatchQueue = UniqueBatchQueue;